import type { FC } from 'react';
import { Outlet } from 'react-router-dom';

import ErrorBoundary from '@/app/ErrorBoundary';
import { usePublicLayout } from '@/hooks/usePublicLayout.hook';
import SiteFooter from '@/layouts/components/SiteFooter';
import SiteHeader from '@/layouts/components/SiteHeader';

const PublicLayout: FC = () => {
  const { headerLinks, headerCta, footerProductLinks, year } = usePublicLayout();

  return (
    <div className="font-body flex min-h-screen flex-col bg-white">
      <SiteHeader links={headerLinks} ctaLabel={headerCta.label} ctaHref={headerCta.href} />

      <main className="flex-1">
        {/* Page-scoped so a crash in one section still leaves the header, footer
            and the legal links reachable. */}
        <ErrorBoundary scope="public-page">
          <Outlet />
        </ErrorBoundary>
      </main>

      <SiteFooter productLinks={footerProductLinks} year={year} />
    </div>
  );
};

export default PublicLayout;
